import { useEffect, useState } from 'react';
import './_SubscribedFeedsContainer.scss';
import { litrals } from '../../../../../constants/Litrals';
import Alert from '../../../../ntisui/Atoms/Alerts';
import SubscribedFeedsCard from '../../../../ntisui/Molecules/SubscribedFeedsCard';
// import DataFeedModal from '../DataFeedModal';
import ConfirmDeleteFeedModal from '../ConfirmDeleteFeedModal';
import { useMsal } from '@azure/msal-react';
import noDataErrorImage from '../../../../../assets/images/error_subscribedfeeds.svg';
import noDataImage from '../../../../../assets/images/no_subscribed_feeds.svg';
import {
  getSubscribedFeedData,
  getUpdatedFeedData,
} from '../../../../../components/public/SubscriberDataFeed/molecules/SubscribedFeedsContainer/SubscribedFeedsContainer.actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootStore } from '../../../../../store';
import NoSubscribedFeed from '../NoSubscribedFeed';
import { Card, Spinner } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { deleteData, updateData } from '../../../../../api/ApiCommunication';
import { IHistory } from '../types/IAvailableFeed';
import { AlertType } from '../../organisms/types/IConfigureDataFeed';

const SubscribedFeedsContainer = () => {
  const history = useHistory<IHistory>();
  const { accounts } = useMsal();
  //   const [showModal, setShowModal] = useState(false);
  //   const [modalData, setModaldata] = useState(null);
  const [showConfirmDeleteFeedModal, setShowConfirmDeleteFeedModal] =
    useState(false);
  const [confirmDeleteFeedModalData, setConfirmDeleteFeedModalData] =
    useState(null);
  const [retry, setRetry] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [isAlert, setIsAlert] = useState('');
  const [isDeleteFeedAlert, setIsDeleteFeedAlert] = useState('');
  const [isUpdate, setIsUpdate] = useState(false);

  /**
   * show info modal
   * @param info
   */
  //   const handleModal = (info: any) => {
  //     setShowModal(true);
  //     setModaldata(info);
  //   };

  /**
   * Show confirm delete feed modal
   * @param info
   */
  const handleConfirmDeleteFeedModal = (info: any) => {
    setShowConfirmDeleteFeedModal(true);
    setConfirmDeleteFeedModalData(info);
  };

  /**
   * Haandle keyboard accecibility
   * @param e
   * @param item
   */
  const handleOnEnterClick = (e: KeyboardEvent, item: any) => {
    if (e.key === 'Enter') {
      handleConfirmDeleteFeedModal(item);
    }
  };

  const dispatch = useDispatch();

  const subscribedDataFeeds: any = useSelector<RootStore>(
    (state) => state.subscribedDataFeed.subscribedFeeds,
  );

  const subscribedDataFeedsError: any = useSelector<RootStore>(
    (state) => state.subscribedDataFeed.error,
  );

  const loading: any = useSelector<RootStore>(
    (state) => state.subscribedDataFeed.loading,
  );
  const emailAddress = (accounts && accounts[0] && accounts[0].username) || '';
  const userId = (accounts && accounts[0] && accounts[0].localAccountId) || '';

  const params = {
    emailAddress: emailAddress,
  };

  const subscriberDataFeeds = () => {
    dispatch(getSubscribedFeedData(params));
  };

  /**
   * Dispatch updated datafeed
   */
  const updatedDataFeeds = () => {
    dispatch(getUpdatedFeedData(params));
  };

  /**
   * Get subscribed datafeed
   */
  const getSubscribedFeeds = () => {
    subscriberDataFeeds();
    setRetry(true);
  };

  /**
   * handle disbaled datafeed toggle
   */
  const handleChange = () => {
    setToggle(!toggle);
    setIsUpdate(true);
  };

  useEffect(() => {
    const data = { isDisabled: toggle };
    isUpdate &&
      updateData('disabledAllDataFeeds', data, `?isDisabled=${toggle}`)
        .then(() => {
          setIsAlert(AlertType.Success);
          subscriberDataFeeds();
          setIsUpdate(false);
        })
        .catch(() => {
          setIsAlert(AlertType.Error);
        });
  }, [toggle]);

  useEffect(() => {
    setTimeout(() => {
      setIsAlert('');
    }, 6500);
  }, [isAlert]);

  useEffect(() => {
    subscriberDataFeeds();
  }, []);

  const deleteDataFeed = () => {
    const data = {
      subscriptionId: confirmDeleteFeedModalData.subscriptionId,
    };

    deleteData(
      'updateUserFeed',
      data,
      `/${confirmDeleteFeedModalData?.subscriptionId}`,
    )
      .then(() => {
        setIsDeleteFeedAlert(AlertType.Success);
        updatedDataFeeds();
      })
      .catch(() => {
        setIsDeleteFeedAlert(AlertType.Error);
      });
    setShowConfirmDeleteFeedModal(false);
  };

  const disabledFeedStatus = subscribedDataFeeds?.filter(
    (item: any) => item.disabled === true,
  );
  useEffect(() => {
    disabledFeedStatus?.length === subscribedDataFeeds.length
      ? setToggle(true)
      : setToggle(false);
  }, [subscribedDataFeeds]);

  return (
    <div
      className="SubscribedFeedsContainer"
      data-testid="subscribed-datafeed-container"
    >
      {!loading ? (
        <>
          {isAlert ? (
            <Alert
              message={
                isAlert == AlertType.Success
                  ? toggle
                    ? litrals.alertSuccessDisabled
                    : litrals.alertSuccessActive
                  : litrals.alertError
              }
              alert={isAlert}
            />
          ) : (
            ''
          )}
          {isDeleteFeedAlert ? (
            <Alert
              message={
                isDeleteFeedAlert == AlertType.Success
                  ? litrals.deleteFeedSuccess
                  : litrals.deleteFeedError
              }
              alert={isDeleteFeedAlert}
            />
          ) : (
            ''
          )}

          {!subscribedDataFeedsError && subscribedDataFeeds?.length ? (
            <>
              <p className="subscribedfeeds-section-heading">
                {litrals.yourConfiguredDataFeeds}
              </p>
              <div>
                <Card className="disabled-card">
                  <div>
                    <Card.Text
                      className="card-text"
                      data-testid="feed-name-text"
                    >
                      {litrals.disabledAllFeeds}
                    </Card.Text>
                  </div>
                  <label className="switch disbaled-toggle">
                    <input
                      data-testid="disabled-all-feeds"
                      type="checkbox"
                      checked={toggle}
                      onChange={() => handleChange()}
                      onKeyPress={() => handleChange()}
                    />
                    <span className="slider round"></span>
                  </label>
                </Card>
              </div>
              {subscribedDataFeeds.map((item: any, index: any) => {
                return (
                  <SubscribedFeedsCard
                    key={'subscribedfeedscard' + index}
                    feedname={item.feedTypeName}
                    showTrashIcon={true}
                    // onInfoIconClick={() => handleModal(item)}
                    onTrashIconClick={() => handleConfirmDeleteFeedModal(item)}
                    onEnterClick={(e: any) => handleOnEnterClick(e, item)}
                    onButtonClick={() =>
                      history.push({
                        pathname: `/subscriberportal/editdatafeed/${item.subscriptionFeedTypeId}`,
                        state: {
                          data: {
                            ...item,
                            name: item.feedTypeName,
                          },
                          emailAddress: emailAddress,
                          userId: userId,
                          action: 'edit',
                        },
                      })
                    }
                    status={item.disabled}
                    statusClass={`status-${
                      item.disabled ? 'disabled' : 'active'
                    }`.toLowerCase()}
                    buttonText={litrals.edit}
                  />
                );
              })}
              {/* <DataFeedModal
                onClose={() => setShowModal(false)}
                show={showModal}
                title={modalData?.feedTypeName}
                content={modalData?.dataFeedDescription}
              /> */}
              <ConfirmDeleteFeedModal
                onClose={() => setShowConfirmDeleteFeedModal(false)}
                onConfirm={() => deleteDataFeed()}
                show={showConfirmDeleteFeedModal}
                title={litrals.removeFeed}
                content={`${litrals.removeFeedConfirmationContent} -${confirmDeleteFeedModalData?.feedTypeName}- ${litrals.feed}?`}
              />
            </>
          ) : (
            !subscribedDataFeedsError && (
              <NoSubscribedFeed
                image={noDataImage}
                message={litrals.noDataFeedsConfigured}
                button={false}
              />
            )
          )}
          {subscribedDataFeedsError && (
            <NoSubscribedFeed
              image={noDataErrorImage}
              message={litrals.subscribedFeedsError}
              button={true}
              onClick={() => getSubscribedFeeds()}
              disabled={subscribedDataFeedsError && retry}
            />
          )}
        </>
      ) : (
        <div className="subscribed-datafeed-loader">
          <Spinner animation="border" role="status" />
        </div>
      )}
    </div>
  );
};
export default SubscribedFeedsContainer;
